import { NgModule } from '@angular/core';
import { NgLmapComponent } from './ng-lmap.component';
import { LmapDirective } from './openlayers/lmap.directive';
import { SizeeventDirective } from './openlayers/sizeevent.directive';
import { GeoSvgDirective } from './openlayers/geo-svg.directive';
import { DrawDirective } from './openlayers/draw.directive';
import { PolygonDirective } from './openlayers/polygon.directive';


@NgModule({
  imports: [
  ],
  declarations: [NgLmapComponent, LmapDirective, SizeeventDirective, GeoSvgDirective, DrawDirective, PolygonDirective],
  exports: [NgLmapComponent, LmapDirective, SizeeventDirective, GeoSvgDirective, DrawDirective, PolygonDirective]
})
export class NgLmapModule { }
